import type { GameProviderChip } from '@shared/hooks';
import type { GameDetails } from '../casino/types/types';

const matchesGameProvider = (gameProviders: string[] | undefined, targetProvider: string): boolean => {
  if (!gameProviders?.length) return false;

  return gameProviders.some(provider => provider && provider.toLowerCase().includes(targetProvider.toLowerCase()));
};

const getAvailableGameProviders = (games: GameDetails[], allProviders: GameProviderChip[]): GameProviderChip[] => {
  return allProviders.filter(staticProvider => games.some(game => matchesGameProvider(game.provider, staticProvider.value)));
};

const getGameProvidersKey = (providers: GameProviderChip[]): string => providers.map(provider => provider.value).join(',');

const areGameProvidersEqual = (currentProviders: GameProviderChip[], nextProviders: GameProviderChip[]): boolean => {
  return getGameProvidersKey(currentProviders) === getGameProvidersKey(nextProviders);
};

export { areGameProvidersEqual, getAvailableGameProviders, getGameProvidersKey, type GameProviderChip };
